module.exports = __webpack_public_path__ + "static/img/Tip_board.a9f7833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/Tip_board.png
// module id = y16o
// module chunks = 1